const theme = {
  colors: {
    // None for this app yet, most of it is just black
    contrast: (value) => ({
      50: '',
      100: '',
      200: '',
      300: '',
      400: '',
      500: '',
      600: '',
      700: '',
      800: '',
      900: '',
      950: '',
    }[value]),
    // Locharma
    primary: (value) => ({
      50: '#effaff',
      100: '#daf3ff',
      200: '#beebff',
      300: '#91dfff',
      400: '#5ecbfc',
      500: '#38aff9',
      600: '#2293ee',
      700: '#1976d2',
      800: '#1c63b1',
      900: '#1c548c',
      950: '#163355',
    }[value]),
    // Persian Green
    secondary: (value) => ({
      50: '#effefb',
      100: '#c7fff5',
      200: '#90ffec',
      300: '#51f7e1',
      400: '#1de4d0',
      500: '#04c8b7',
      600: '#00a89d',
      700: '#058079',
      800: '#0a6561',
      900: '#0d5451',
      950: '#003333',
    }[value]),
    // Golden Grass
    tertiary: (value) => ({
      50: '#faf8ec',
      100: '#f4eecd',
      200: '#ebdc9d',
      300: '#dfc365',
      400: '#d4a939',
      500: '#c5942d',
      600: '#a97425',
      700: '#885520',
      800: '#714622',
      900: '#613b22',
      950: '#381e10',
    }[value]),
    indicator: function() { return '#00FF00' },
    onlineIndicator: function() { return '#7EF4E1' },
    recentIndicator: function() { return '#ffe99c' },
    success: function(value) { return this.secondary(value) },
    warning: function(value) { return this.tertiary(value) },
    statusColors: {
      browsing: (value) => ({
        primary: '#3750bf',
        light: '#889efc',
        lightRgba: (value) => `rgba(136, 157, 252, ${value})`,
      }[value]),
      right_now: (value) => ({
        primary: '#6A23FF',
        light: '#bd9eff',
        lightRgba: (value) => `rgba(189, 158, 255, ${value})`,
      }[value]),
      chatting: (value) => ({
        primary: '#2F9BE9',
        light: '#99d4ff',
        lightRgba: (value) => `rgba(153, 213, 255, ${value})`,
      }[value]),
      meetup: (value) => ({
        primary: '#E3B100',
        light: '#ffe99c',
        lightRgba: (value) => `rgba(255, 234, 156, ${value})`,
      }[value]),
      romance: (value) => ({
        primary: '#9400D3',
        light: '#bc62e3',
        lightRgba: (value) => `rgba(188, 98, 227, ${value})`,
      }[value]),
    },
    // Material Red
    error: (value) => ({
      50: '#FCE4EC',
      100: '#F8BBD0',
      200: '#F48FB1',
      300: '#F06292',
      400: '#EC407A',
      500: '#E91E63',
      600: '#D81B60',
      700: '#C2185B',
      800: '#AD1457',
      900: '#880E4F',
      950: '57002E',
    }[value]),
  },
  // The spacing is 8px based which is very common among themes.
  //   - (16px per rem, so multiply by 0.5 to get 8px)
  // Try to keep this to integer values, but it's fine to make
  // the spacing 0.5, etc, for extremely small values.
  sizing: {
    size: (number) => `${number * 0.5}rem`,
    appTopbar: function() { return this.size(6) },
    appBottombar: function() { return this.size(6) },
    nearbyProfileScrollerTop: function() { return this.size(16) },
  },
  fontSize: (size) => ({
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    smd: '0.9375rem', // 15px
    md: '1rem',       // 16px
    lg: '1.125rem',   // 18px
    xl: '1.3125rem',  // 21px
  }[size]),
  getRemValue: () => parseFloat(getComputedStyle(document.documentElement).fontSize),
  glassBackgruond: (alpha=0.8, blurPx='10px') => `
    background-color: rgba(0,0,0,${alpha});
    backdrop-filter: blur(${blurPx});
  `
}

export let colors = theme.colors
export let size = theme.sizing.size
export let fonts = theme.fonts
export let fontSize = theme.fontSize
export let getRemValue = theme.getRemValue
export let glassBackground = theme.glassBackgruond
export let appTopbar = theme.sizing.appTopbar()
export let appBottombar = theme.sizing.appBottombar()
export let nearbyProfileScrollerTop = theme.sizing.nearbyProfileScrollerTop()
export default theme;
